import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const typedKeys = <T extends object>(obj: T) => Object.keys(obj) as Array<keyof T>;
